import dynamic from "next/dynamic";
import ReservationsLoading from "./Loaders/ReservationsLoading";
// import OwnerPanel from "./Pages/OwnerPanel";
// import Detail from "../components/Pages/Detail";
// import Blank from "../components/Pages/Blank";
// import BlogList from "../components/Pages/BlogList";
// import Contact from "../components/Pages/Contact";
// import BlogDetail from "../components/Pages/BlogDetail";
// import ProductCategory from "../components/Pages/ProductCategory";
// import Reservation from "../components/Pages/Reservation";
// import CategoryList from "../components/Pages/CategoryList";
// import CheckinInformation from "../components/Pages/CheckinInformation";
// import Payment from "../components/Pages/Payment";
// import Reservations from "../components/Pages/Reservations";

const Detail = dynamic(() => import("../components/Pages/Detail"));
const Blank = dynamic(() => import("../components/Pages/Blank"));
const BlogList = dynamic(() => import("../components/Pages/BlogList"));
const Contact = dynamic(() => import("../components/Pages/Contact"));
const BlogDetail = dynamic(() => import("../components/Pages/BlogDetail"));
const ProductCategory = dynamic(
  () => import("../components/Pages/ProductCategory"),
);
const Reservation = dynamic(() => import("../components/Pages/Reservation"));
const CategoryList = dynamic(() => import("../components/Pages/CategoryList"));
const CheckinInformation = dynamic(
  () => import("../components/Pages/CheckinInformation"),
);
const Payment = dynamic(() => import("../components/Pages/Payment"));
const Reservations = dynamic(() => import("../components/Pages/Reservations"));
const OwnerPanel = dynamic(() => import("../components/Pages/OwnerPanel"));
const BankTransferForm = dynamic(
  () => import("../components/Pages/BankTransferForm"),
);

// const Structural = dynamic(() => import("./Structural"));

const DynamicComp = (props) => {
  const c = {
    Detail: Detail,
    Page: Blank,
    BlogList: BlogList,
    BlogDetail: BlogDetail,
    Contact: Contact,
    ProductCategory: ProductCategory,
    Reservation: Reservation,
    Category: CategoryList,
    CheckinInformation: CheckinInformation,
    Payment: Payment,
    Reservations: Reservations,
    Owner: OwnerPanel,
    BankTransfer: BankTransferForm,
  };
  const Comp = c[props.RoutingController];

  return (
    <>
      {/* <Structural data={props.ssr.result.Structural} /> */}
      <Comp {...props} action={props.action} />
    </>
  );
};

export default DynamicComp;
